import { Action, State, StateContext, Store } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { MassiveActions } from './massive.actions';
import { MassiveNotification, MassiveResponse } from '../../models/massive.model';

export interface MassiveActionsStateModel {
  massiveNotification: MassiveNotification,
  massiveResponse: MassiveResponse
}

const defaults = {
  massiveNotification: undefined,
  massiveResponse: undefined
}

@State<MassiveActionsStateModel>({
  name: 'massiveState',
  defaults
})
@Injectable()
export class MassiveActionsState {
  constructor() {}

  @Action(MassiveActions.UpdateMassiveNotification)
  updateMassiveNotification(
    ctx: StateContext<MassiveActionsStateModel>,
    { massiveNotification }: MassiveActions.UpdateMassiveNotification
  ) {
    ctx.patchState({
      massiveNotification: massiveNotification
    });
  }

  @Action(MassiveActions.SetMassiveResponse)
  setMassiveResponse(
    ctx: StateContext<MassiveActionsStateModel>,
    { massiveResponse }: MassiveActions.SetMassiveResponse
  ) {
    ctx.patchState({
      massiveResponse: massiveResponse
    });
  }

  @Action(MassiveActions.SetDefaultState)
  setDefaultState(
    ctx: StateContext<MassiveActionsStateModel>, { }: MassiveActions.SetDefaultState) {
    ctx.patchState(defaults);
  }
}
